<template>
  <div class="login-container">
    <div class="login-form">
      <img class="logo" src="../assets/stockantsLogo.png" alt="Organization Logo" />

      <!-- <h2 class="signin-heading">SIGN IN</h2> -->
      <div class="small-text">Login on StockAnts using your email address</div>

      <form @submit.prevent="login">
        <div class="input-group">
          <label for="email">EMAIL ADDRESS</label>
          <input type="email" id="email" v-model="email" required />
        </div>

        <div class="input-group" style="position: relative;">
          <label for="password">PASSWORD</label>
          <input :type="showPassword ? 'text' : 'password'" id="password" v-model="password" class="password-input"
            required />
          <img v-if="showPassword" src="../assets/images/visibility.png" class="password-visibility"
            @click="togglePasswordVisibility" />
          <img v-else src="../assets/images/eye.png" @click="togglePasswordVisibility" class="password-visibility" />
        </div>

        <button class="signin-button" type="submit" :disabled="isLoginLoading">
          <i v-if="isLoginLoading" class="el-icon-loading" style="margin-right: 5px;"></i>
          SIGN IN
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { serverAddr } from "@/networkConfig";
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      remember: false,
      showForgotPassword: false,
      forgotPasswordEmail: "",
      isLoginLoading: false,
    };
  },
  mounted() { },

  methods: {
    // ...mapMutations(["resetAllState"]), // Map the resetAllState mutation
    async login() {
      this.isLoginLoading = true;

      serverAddr
        .post("/admin_dashboard/admin_login", {
          username: this.email,
          password: this.password,
        })
        .then((response) => {
          if (response.data.status) {
            // Handle successful login
            this.$notify({
              title: "Successful",
              message: response.data.validation,
              type: "success",
            });

            // Save profile data in local storage
            const profileData = response.data.profile_data.profile_data;
            const userData = response.data.profile_data.user_data;

            this.$store.commit("resetAllState");

            localStorage.setItem("profileData", JSON.stringify(profileData));
            const userRoles = userData.roles;
            localStorage.setItem("userRoles", JSON.stringify(userRoles));

            const brokerCompanyName =
              profileData.extra_info.broker_company_name;
            const companyUrl = profileData.extra_info.company_url;

            localStorage.setItem("broker_company_name", brokerCompanyName);
            localStorage.setItem("company_url", companyUrl);

            this.$store.dispatch("someAction", { somePayload: "someValue" });

            this.$router.push("/broker-dashboard-analytics");
          }
          this.isLoginLoading = false;
        })
        .catch(
          function (error) {
            this.isLoginLoading = false;
            console.log(error);
          }.bind(this)
        );
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    resetPassword() { },
  },
};
</script>

<style scoped>
.login-container {
  background-image: url("../assets/background.png");
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  font-family: sans-serif, montserrat;
}

.login-form {
  padding: 20px;
  width: 300px;
  text-align: center;
  color: #777;
}

.logo {
  width: 275px;
  height: auto;
}

.signin-heading {
  font-size: 25px;
  height: 22px;
  margin-top: 0px;
  margin-bottom: 7px;
  color: black;
  letter-spacing: 2px;
}

.small-text {
  font-size: 14px;
  margin-bottom: 35px;
  font-weight: lighter;
  margin-left: 0px;
  text-align: center;
}

.input-group {
  margin-bottom: 15px;
  text-align: left;
}

label {
  display: block;
  font-size: smaller;
  font-weight: bolder;
  margin-bottom: 5px;
  margin-left: 7px;
  color: rgb(11, 10, 10);
}

input[type="email"],
input[type="password"] {
  width: 90%;
  padding: 2px;
  border-bottom: 2px solid #777;
  outline: none;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  align-items: center;
  margin-left: 7px;
  margin-bottom: 5px;
  background: transparent;
}

.password-input {
  width: 90%;
  padding: 2px;
  border-bottom: 2px solid #777;
  outline: none;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  align-items: center;
  margin-left: 7px;
  margin-bottom: 5px;
}

.forgot-password {
  display: block;
  margin-top: 20px;
  text-decoration: none;
  color: #777;
  font-size: small;
  font-weight: lighter;
}

.password-visibility {
  position: absolute;
  right: 10px;
  top: 15px;
  z-index: 1;
  width: 20px;
}

.input-group {
  margin-bottom: 20px;
}

.input-group label {
  display: block;
  margin-bottom: 0px;
}

.password-input:focus {
  outline: none;
  border-bottom: 2px solid #000;
}

.password-visibility {
  position: absolute;
  right: 25px;
  top: 65%;
  transform: translateY(-50%);
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.signin-button {
  display: block;
  width: 100%;
  padding: 10px;
  background-color: rgb(51, 69, 141);
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 25px;
}

.signin-button[disabled] {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>
